import type { ThemeMetadata } from './types';

export const chantier: ThemeMetadata = {
  name: 'chantier',
  label: 'Chantier',
  vibe: 'Énergique, fierté du volume. Pour les fratries jeunes qui voient grand.',
  preview: {
    background: '#FFFFFF',
    surface: '#F8F8F8',
    accent: '#D62828',
  },
};
